import styled from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const WarningCodeText = styled(Text)`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  padding: 2px ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.warning.surface};
  color: ${props => props.theme.colors.warning.onSurface};
  width: fit-content;
  border-radius: 2px;
`
